const AVATAR_STATE = Object.freeze({
    birthday: 'birthday',
    blocked: 'blocked',
    bookmarked: 'bookmarked',
    deceased: 'deceased',
    validated: 'validated',
});
const AVATAR_ICONS = Object.freeze({
    [AVATAR_STATE.birthday]: {
        bgColor: 'primary',
        color: 'white',
        name: 'cake-candles',
        size: '50%',
    },
    [AVATAR_STATE.blocked]: {
        color: 'fire',
        name: 'circle-xmark',
    },
    [AVATAR_STATE.bookmarked]: {
        color: 'primary',
        name: 'circle-star',
    },
    [AVATAR_STATE.validated]: {
        color: 'grass',
        name: 'circle-check',
    },
});
export { AVATAR_ICONS, AVATAR_STATE };
//# sourceMappingURL=constants.js.map